import type {ComposerTranslation} from "vue-i18n";
import {GroupLocation} from "@/model/group-location";

export const getGroupLangOptions = (t: ComposerTranslation) => {
    return [
        {value: "ENG", text: t("ENGLISH")},
        {value: "RUS", text: t("RUSSIAN")},
        {value: "EST", text: t("ESTONIAN")},
        {value: "UKR", text: t("UKRAINIAN")},
        {value: "TUR", text: t("TURKEY")},
        {value: "ARA", text: t("ARABIC")},
        {value: "FAR", text: t("FARSI")},
        {value: "DAR", text: t("DARI")},
        {value: "PAS", text: t("PASHTO")},
    ];
};

export const getGroupLocationOptions = (t: ComposerTranslation) => {
    return [
        {value: "Tallinn", text: t("TALLINN")},
        {value: "Tartu", text: t("TARTU")},
        {value: "Narva", text: t("NARVA")},
        {value: "Alutaguse", text: t("ALUTAGUSE")},
        {value: "Anija", text: t("ANIJA")},
        {value: "Antsla", text: t("ANTSLA")},
        {value: "Aseri", text: t("ASERI")},
        {value: "Elva", text: t("ELVA")},
        {value: "Haapsalu", text: t("HAAPSALU")},
        {value: "Haljala", text: t("HALJALA")},
        {value: "Harku", text: t("HARKU")},
        {value: "Hiiumaa", text: t("HIIUMAA")},
        {value: "Häädemeeste", text: t("HAADEMEESTE")},
        {value: "Jõelähtme", text: t("JOELAHTME")},
        {value: "Jõgeva", text: t("JOGEVA")},
        {value: "Jõhvi", text: t("JOHVI")},
        {value: "Järva", text: t("JARVA")},
        {value: "Jüri", text: t("JURI")},
        {value: "Kadrina", text: t("KADRINA")},
        {value: "Kambja", text: t("KAMBJA")},
        {value: "Kanepi", text: t("KANEPI")},
        {value: "Kastre", text: t("KASTRE")},
        {value: "Kehtna", text: t("KEHTNA")},
        {value: "Keila", text: t("KEILA")},
        {value: "Kihnu", text: t("KIHNU")},
        {value: "Kiili", text: t("KIILI")},
        {value: "Kiviõli", text: t("KIVIOLI")},
        {value: "Kohila", text: t("KOHILA")},
        {value: "Kohtla-Järve", text: t("KOHTLA_JARVE")},
        {value: "Kose", text: t("KOSE")},
        {value: "Kunda", text: t("KUNDA")},
        {value: "Kuusalu", text: t("KUUSALU")},
        {value: "Loksa", text: t("LOKSA")},
        {value: "Luunja", text: t("LUUNJA")},
        {value: "Lääne-Nigula", text: t("LAANE_NIGULA")},
        {value: "Lääneranna", text: t("LAANERANNA")},
        {value: "Lüganuse", text: t("LUGANUSE")},
        {value: "Maardu", text: t("MAARDU")},
        {value: "Muhu", text: t("MUHU")},
        {value: "Mulgi", text: t("MULGI")},
        {value: "Mustvee", text: t("MUSTVEE")},
        {value: "Märjamaa", text: t("MARJAMAA")},
        {value: "Narva-Jõesuu", text: t("NARVA_JOESUU")},
        {value: "Nõo", text: t("NOO")},
        {value: "Otepää", text: t("OTEPAA")},
        {value: "Paide", text: t("PAIDE")},
        {value: "Paldiski", text: t("PALDISKI")},
        {value: "Peipsiääre", text: t("PEIPSIAARE")},
        {value: "Põhja-Sakala", text: t("POHJA_SAKALA")},
        {value: "Põltsamaa", text: t("POLTSAMAA")},
        {value: "Põlva", text: t("POLVA")},
        {value: "Pärnu", text: t("PARNU")},
        {value: "Raasiku", text: t("RAASIKU")},
        {value: "Rae", text: t("RAE")},
        {value: "Rakvere", text: t("RAKVERE")},
        {value: "Rapla", text: t("RAPLA")},
        {value: "Ruhnu", text: t("RUHNU")},
        {value: "Rõuge", text: t("ROUGE")},
        {value: "Räpina", text: t("RAPINA")},
        {value: "Saarde", text: t("SAARDE")},
        {value: "Saaremaa", text: t("SAAREMAA")},
        {value: "Saku", text: t("SAKU")},
        {value: "Saue", text: t("SAUE")},
        {value: "Setomaa", text: t("SETOMAA")},
        {value: "Sillamäe", text: t("SILLAMAE")},
        {value: "Tapa", text: t("TAPA")},
        {value: "Toila", text: t("TOILA")},
        {value: "Tori", text: t("TORI")},
        {value: "Tõrva", text: t("TORVA")},
        {value: "Türi", text: t("TURI")},
        {value: "Valga", text: t("VALGA")},
        {value: "Viimsi", text: t("VIIMSI")},
        {value: "Viljandi", text: t("VILJANDI")},
        {value: "Vinni", text: t("VINNI")},
        {value: "Viru-Nigula", text: t("VIRU_NIGULA")},
        {value: "Vormsi", text: t("VORMSI")},
        {value: "Võru", text: t("VORU")},
        {value: "Väike-Maarja", text: t("VAIKE_MAARJA")},
        {value: GroupLocation.ONLINE, text: t("ONLINE")},
        {value: GroupLocation.IN_HOUSE, text: t("IN_HOUSE")},
        {value: "Laev Isabelle", text: t("SHIP_ISABELLE")},
    ];
};

export interface TrainingGroupDocumentResponse {
    fileId: string;
    fileName: string;
    contentDescription: string;
    createdAt: string;
    createdBy: string;
}
